/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentSyncProgressData } from './appointmentSyncProgressData';
import { ToastConfig } from './toastConfig';


/**
 * WebSocket notification for appointment sync progress.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentSyncProgressNotification { 
    /**
     * Always \'appointment.sync_progress\'
     */
    readonly type: string;
    data: AppointmentSyncProgressData;
    toast?: ToastConfig | null;
}
export const AppointmentSyncProgressNotification_type_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncProgressNotification_data_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncProgressNotification_toast_Validators: ValidatorFn[] =
    [ ];


